function Page404() {
    return (
        <>
            <h1>404 - Not Found</h1>
        </>
    )
}

export default Page404;
